import { t } from "i18next";

import { LocalData } from "../../../General/LocalData";
import { NotificationData } from "../NotificationData";

export class NotificationTaskActivityData extends NotificationData {
  propertyID: string = "";
  deviationID: string = "";
  taskID: string = ""; 
  taskName: string = "";
  authorID: string = "";
  authorName: string = "";

  updateData: any = {};
    statusData?: any = {};
  /*
  {
	responsible: string[], // user id
	statusData: {
		value: number,
		changedBy: userID,
        changedDate: timestamp
    }
  }
  */

  setup(data: any) {
    super.setup(data)
    this.type = NotificationData.types.TASK_ACTIVITY;

    if(data.notificationData){
      this.propertyID = data.notificationData?.propertyID ?? "";
      this.deviationID = data.notificationData?.deviationID ?? "";
      this.taskID = data.notificationData?.taskID ?? "";
      this.taskName = data.notificationData?.taskName ?? "";
      this.authorID = data.notificationData?.authorID ?? "";
      this.authorName = data.notificationData?.authorName ?? "";
      this.updateData = data.notificationData?.updateData ?? {};
      this.statusData = data.notificationData?.updateData.statusData ?? {};
      
      this.title = this.taskName;

      if(this.statusData){
        this.body = `${this.authorName} ${t('main.taskNotification_updatedStatusTo')} ${this.statusData.value}`;
      }else if(this.updateData.responsible){
        this.body = `${this.authorName} ${t('main.taskNotification_changedResponsibility')} ${this.updateData.responsible}`;
      }else{
        this.body = `${this.authorName} ${t('main.taskNotification_updatedTask')}`;
      }

      this.userForImageView = LocalData.users.addData(this.authorID);

      this.redirectPath = `/properties/${this.propertyID}/tasks/${this.deviationID}&sId=${this.taskID}`;
    }
  }
}